<template>
    <b-modal :visible="isLoading"
             centered
             no-close-on-backdrop
             no-close-on-esc
             hide-header
             hide-footer
             content-class="bg-transparent border-0">
    <div class="text-center">
      <div class="spinner-border text-light" role="status"></div>
    </div>
    </b-modal>
</template>

<script>
export default {
  name: "mmf-loading-panel",
  props: {
    isLoading: Boolean
  }
}
</script>